import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
// Styling converted to TailwindCSS — removed modular CSS import
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { signup } from "../../store/actions/loginActions";
import ModalComponent from "../../components/Modals/Modal";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { handleValidatePhoneNumber } from "../../Utilities/general";

function Register() {
  // state to restrict multipel clicks
  const [buttonClicked, setButtonClicked] = useState(false);
  // state to display errors
  const [error, seterror] = useState("");
  //history for routing
  const history = useNavigate();
  // dispatch actions
  const dispatch = useDispatch();
  //firstName
  const [firstName, setfirstName] = useState("");
  //last name
  const [lastName, setlastName] = useState("");
  //email
  const [email, setemail] = useState("");
  //phoneNo
  const [phoneNo, setphoneNo] = useState("");
  //password
  const [password, setpassword] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [passwordStrength, setpasswordStrength] = useState(0);
  // show password toggle
  const [showPassword, setShowPassword] = useState("password");
  // show password2 toggle
  const [showPassword2, setShowPassword2] = useState("password");
  //confirmPass
  const [confirmPassword, setconfirmPassword] = useState("");
  // terms and conditions
  const [TnC, setTnC] = useState(false);
  // custom alert state
  const [modalFields, setModalFields] = useState({
    open: false,
    text: "",
    btnText1: "Ok",
    closeFunc: () => {
      setModalFields({ ...modalFields, open: false });
    },
  });

  useEffect(() => {
    try {
      let makeBtnClickable;

      if (buttonClicked) {
        makeBtnClickable = setTimeout(() => {
          setButtonClicked(false);
        }, 10000);
      }
      return () => clearTimeout(makeBtnClickable);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [buttonClicked]);

  // useEffect to show error modal
  useEffect(() => {
    try {
      if (error) {
        setModalFields({
          ...modalFields,
          open: true,
          text: error,
        });
        seterror("");
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    if (loaded) {
      const tempSignupObj = {
        email: email ?? "",
        firstName: firstName ?? "",
        lastName: lastName ?? "",
        password: password ?? "",
        confirmPassword: confirmPassword ?? "",
        phone: phoneNo ?? "",
      };
      localStorage.setItem("signupObj", JSON.stringify(tempSignupObj));
    }
  }, [email, firstName, lastName, password, phoneNo, confirmPassword, loaded]);

  useEffect(() => {
    let tempSignupObj = localStorage.getItem("signupObj");
    if (tempSignupObj) {
      tempSignupObj = JSON.parse(tempSignupObj);
      if (tempSignupObj && tempSignupObj != "undefined") {
        setemail(tempSignupObj.email);
        setfirstName(tempSignupObj.firstName);
        setlastName(tempSignupObj.lastName);
        setpassword(tempSignupObj.password);
        setconfirmPassword(tempSignupObj.confirmPassword);
        setphoneNo(tempSignupObj.phone);
      } else localStorage.removeItem("signupObj");
    }
    setLoaded(true);
  }, []);

  // check password strength
  const handleSetPassword = (e) => {
    try {
      const pwd = (e || "").toString();
      let strengthLevel = 0;
      const passArray = [...pwd];
      setpassword(pwd);
      if (pwd.length > 0) {
        const hasLowerCase = passArray?.filter(
          (letter) => letter >= "a" && letter <= "z"
        );
        const hasUpperCase = passArray?.filter(
          (letter) => letter >= "A" && letter <= "Z"
        );
        const hasNumber = passArray?.filter(
          (letter) => letter >= "0" && letter <= "9"
        );
        const hasSC1 = passArray?.filter(
          (letter) => letter >= "!" && letter <= "/"
        );
        const hasSC2 = passArray?.filter(
          (letter) => letter >= ":" && letter <= "@"
        );
        const hasSC3 = passArray?.filter(
          (letter) => letter >= "[" && letter <= "`"
        );
        const hasSC4 = passArray?.filter(
          (letter) => letter >= "{" && letter <= "~"
        );
        if (hasLowerCase?.length > 0) {
          strengthLevel = strengthLevel + 20;
        }
        if (hasUpperCase?.length > 0) {
          strengthLevel = strengthLevel + 20;
        }
        if (hasNumber?.length > 0) {
          strengthLevel = strengthLevel + 20;
        }
        if (
          hasSC1?.length > 0 ||
          hasSC2?.length > 0 ||
          hasSC3?.length > 0 ||
          hasSC4?.length > 0
        ) {
          strengthLevel = strengthLevel + 20;
        }
        if (e?.length > 5) {
          strengthLevel = strengthLevel + 20;
        }
      }
        // debug log to help diagnose password strength issues
        // (remove this log after debugging)
        // eslint-disable-next-line no-console
        console.log("password-strength-debug", { pwd, strengthLevel });

        setpasswordStrength(strengthLevel);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    setModalFields({
      ...modalFields,
      open: true,
      text: "You have entered an invalid email address!",
    });
    return false;
  }

  // Password validator: at least 6 chars, one upper, one lower, one digit, one special
  function validatePassword(pwd) {
    if (!pwd) return false;
    const re = /^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/;
    return re.test(pwd);
  }

  const handleSignUp = () => {
    try {
      if (TnC) {
        if (
          firstName &&
          lastName &&
          email &&
          phoneNo &&
          password &&
          confirmPassword
        ) {
          if (ValidateEmail(email)) {
            if (validatePassword(password)) {
              if (password === confirmPassword) {
                if (phoneNo?.length === 12) {
                  const signupData = {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    password: password,
                    phone: phoneNo,
                  };
                  console.log("signup data from signup component", signupData);
                  if (!buttonClicked) {
                    setButtonClicked(true);
                    dispatch(signup(signupData, seterror, history, setButtonClicked));
                  }
                } else {
                  setModalFields({
                    ...modalFields,
                    open: true,
                    text: "Invalid phone number!",
                  });
                }
              } else {
                setModalFields({
                  ...modalFields,
                  open: true,
                  text: "Passwords do not match...",
                });
              }
            } else {
              setModalFields({
                ...modalFields,
                open: true,
                text: "Your password must contain at least 6 characters. It should include a mix of upper and lower case letters, numbers, and special characters.",
              });
            }
          }
        } else {
          setModalFields({
            ...modalFields,
            open: true,
            text: "Please fill all the fields!",
          });
        }
      } else {
        setModalFields({
          ...modalFields,
          open: true,
          text: "Please agree to the terms and conditions before proceeding!",
        });
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  const toggleShowPassword = () => {
    if (showPassword === "text") setShowPassword("password");
    else setShowPassword("text");
  };

  const toggleShowPassword2 = () => {
    if (showPassword2 === "text") setShowPassword2("password");
    else setShowPassword2("text");
  };

  return (
    <div className="flex items-start justify-center px-4 w-full pt-6 pb-4" style={{ minHeight: "calc(100vh - 60px)" }}>
      <ModalComponent
        text={modalFields.text}
        openState={modalFields.open}
        closeFunction={() => {
          setModalFields({ ...modalFields, open: false });
        }}
        btnText1={modalFields.btnText1}
        btnClickFunc1={modalFields.closeFunc}
      />


      <div className="w-full max-w-container mx-auto">
        <div className="flex flex-col items-start gap-1 mb-6">
          <h1 className="text-[#211F59] text-2xl font-semibold">You’re almost there!</h1>
          <p className="text-[#211F59] text-base font-medium">Sign up to get moving.</p>
        </div>

        <div className="flex flex-row gap-2 mb-3">
          <div className="w-1/2">
            <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
              <input
                value={firstName}
                placeholder="First name"
                onChange={(e) => setfirstName(e.target.value)}
                className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] h-[48px] rounded-[12px] px-[13.5px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
              />
            </div>
          </div>
          <div className="w-1/2">
            <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
              <input
                value={lastName}
                placeholder="Last name"
                onChange={(e) => setlastName(e.target.value)}
                className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] h-[48px] rounded-[12px] px-[13.5px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
              />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
              <input
                value={email}
                placeholder="Email address"
                type="email"
                onChange={(e) => setemail(e.target.value)}
                className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] h-[48px] rounded-[12px] px-[13.5px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
              />
            </div>
          </div>

          <div>
            <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
              <input
                value={phoneNo}
                placeholder="Phone number"
                onChange={(e) => handleValidatePhoneNumber(e, setphoneNo)}
                className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] h-[48px] rounded-[12px] px-[13.5px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
              />
            </div>
          </div>

          <div className="relative">
            <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
              <input
                value={password}
                type={showPassword}
                placeholder="Password"
                onChange={(e) => handleSetPassword(e?.target?.value)}
                className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] pl-[13.5px] pr-12 h-[48px] rounded-[12px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
              />
            </div>
            <button
              onClick={() => toggleShowPassword()}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5B5472]"
              aria-label="toggle password visibility"
              type="button"
            >
              {showPassword === "password" ? (
                <BsFillEyeFill size={18} />
              ) : (
                <BsFillEyeSlashFill size={18} />
              )}
            </button>
          </div>

          <div className="relative">
            <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
              <input
                value={confirmPassword}
                type={showPassword2}
                placeholder="Confirm password"
                onChange={(e) => setconfirmPassword(e.target.value)}
                className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] pl-[13.5px] pr-12 h-[48px] rounded-[12px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
              />
            </div>
            <button
              onClick={() => toggleShowPassword2()}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5B5472]"
              aria-label="toggle confirm password visibility"
              type="button"
            >
              {showPassword2 === "password" ? (
                <BsFillEyeFill size={18} />
              ) : (
                <BsFillEyeSlashFill size={18} />
              )}
            </button>
          </div>

          <div className="flex items-start gap-2">
            <input
              type="checkbox"
              checked={TnC}
              onChange={(e) => setTnC(e.target.checked)}
              className="w-3 h-3 accent-[#211F59] mt-1"
            />
            <p className="text-[12px] text-[#373559]">By proceeding, I agree to Moovez's <span className="text-[#211F59] font-medium underline cursor-pointer" onClick={() => history('/terms')}>Terms of Use</span> and acknowledge that I have read the <span className="text-[#211F59] font-medium underline cursor-pointer" onClick={() => history('/Privacy')}>Privacy Policy</span>.</p>
          </div>

          <div className="pt-2">
            <button
              className="w-full mt-[6px] bg-[#34318C] text-white rounded-[15px] px-8 h-[48px] text-sm font-medium hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center"
              onClick={handleSignUp}
              disabled={buttonClicked}
              aria-busy={buttonClicked}
            >
              {buttonClicked ? (
                <Box sx={{ display: "flex" }}>
                  <CircularProgress size={18} color="inherit" />
                </Box>
              ) : (
                "Sign up"
              )}
            </button>
          </div>

          <div className="text-center w-full text-[12px] text-[#6B637D] mt-3">
            Already have an account? <span className="text-[#211F59] font-medium cursor-pointer underline" onClick={() => history('/Login')}>Log in</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
